import { render, staticRenderFns } from "./DashboardTxns.vue?vue&type=template&id=0e0c6ae7&scoped=true&"
import script from "./DashboardTxns.vue?vue&type=script&lang=js&"
export * from "./DashboardTxns.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTxns.vue?vue&type=style&index=0&id=0e0c6ae7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0c6ae7",
  null
  
)

export default component.exports